import React from 'react';
import { IconProps } from '../types/types';

const LTCUSD: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 39 41" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <g clipPath="url(#ltcusd_svg__a)">
            <path d="M13.025 26.05c7.193 0 13.025-5.832 13.025-13.025C26.05 5.831 20.218 0 13.025 0 5.831 0 0 5.831 0 13.025 0 20.218 5.831 26.05 13.025 26.05Z" fill="#BFBBBB" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m8.488 15.641-1.162.451.56-2.246 1.176-.472 1.694-6.861h4.175l-1.236 5.043 1.147-.464-.553 2.238-1.162.465-.69 2.836h6.286l-.71 2.907H7.53l.957-3.897Z"
                fill="#fff"
            />
        </g>
        <circle cx={24.703} cy={27.167} r={13.581} fill="#fff" stroke="#fff" strokeWidth={0.5} />
        <path d="M24.701 40.498c7.363 0 13.332-5.968 13.332-13.331 0-7.363-5.969-13.332-13.332-13.332-7.362 0-13.33 5.969-13.33 13.332 0 7.362 5.968 13.331 13.33 13.331Z" fill="#F0F0F0" />
        <path
            d="M24.118 27.167H38.03c0-1.204-.16-2.37-.46-3.478H24.12v3.478ZM24.118 20.211h11.954a13.403 13.403 0 0 0-3.076-3.478h-8.878v3.478ZM24.699 40.498c3.137 0 6.021-1.084 8.299-2.898H16.4a13.274 13.274 0 0 0 8.299 2.898ZM13.326 34.122h22.749a13.253 13.253 0 0 0 1.497-3.478H11.828c.334 1.24.842 2.409 1.498 3.478Z"
            fill="#D80027"
        />
        <path
            d="M17.546 15.917h1.214l-1.13.821.432 1.329-1.13-.821-1.13.82.373-1.147c-.995.829-1.867 1.8-2.586 2.882h.39l-.72.522c-.112.187-.22.377-.322.57l.343 1.057-.64-.465c-.16.337-.306.682-.437 1.034l.379 1.165h1.396l-1.13.821.432 1.329-1.13-.821-.677.491c-.068.545-.103 1.1-.103 1.663h13.332V13.835c-2.634 0-5.09.764-7.157 2.082Zm.516 9.917-1.13-.821-1.13.82.432-1.328-1.13-.82H16.5l.432-1.33.432 1.33h1.396l-1.13.82.432 1.329Zm-.432-5.212.432 1.328-1.13-.82-1.13.82.432-1.328-1.13-.821H16.5l.432-1.329.432 1.329h1.396l-1.13.82Zm5.214 5.212-1.13-.821-1.13.82.432-1.328-1.13-.82h1.396l.432-1.33.431 1.33h1.397l-1.13.82.432 1.329Zm-.432-5.212.432 1.328-1.13-.82-1.13.82.432-1.328-1.13-.821h1.396l.432-1.329.431 1.329h1.397l-1.13.82Zm0-3.884.432 1.329-1.13-.821-1.13.82.432-1.328-1.13-.82h1.396l.432-1.33.431 1.33h1.397l-1.13.82Z"
            fill="#0052B4"
        />
        <defs>
            <clipPath id="ltcusd_svg__a">
                <path fill="#fff" d="M0 0h26.05v26.05H0z" />
            </clipPath>
        </defs>
    </svg>
);

export default LTCUSD;
